import PropTypes from "prop-types";
import {LoadCanvasTemplate, loadCaptchaEnginge, validateCaptcha} from "react-simple-captcha";
import {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import {debounce} from "../../util/util";

const CustomCaptcha = forwardRef((props,ref) => {
    const [inputValue, setInputValue] = useState('');

    const placeholderText = '자동입력 방지 문자 입력';
    const captchaLength = 6;

    const isValidCaptcha = () => {
        if (validateCaptcha(inputValue)) {
            return true;
        } else {
            return false;
        }
    }

    const reloadCaptcha = () => {
        loadCaptchaEnginge(captchaLength);
    }

    useEffect(() => {
        loadCaptchaEnginge(captchaLength); // 6자리 캡챠 생성
    }, []);

    useImperativeHandle(ref, () => ({
        isValidCaptcha,
        reloadCaptcha,
    }));

    const handler = (event) => {
        setInputValue(event.target.value);
    }

    return (
        <div className="d-flex justify-content-center align-items-center flex-wrap">
            {/* 캡챠 이미지 */}
            <div className="border rounded"
            style={{marginTop: '15px', marginBottom: '15px'}}>
                <LoadCanvasTemplate reloadText="🔃"/>
            </div>

            {/* 입력창 */}
            <div className="input-group flex-nowrap border rounded"
                style={{minWidth: '250px'}}
                id={'sendmail-captcha-input'}>
                <span className="input-group-text" id="addon-wrapping">🗝</span>
                <input
                    type="text"
                    className="form-control"
                    placeholder={placeholderText}
                    aria-label={placeholderText}
                    aria-describedby="addon-wrapping"
                    maxLength={captchaLength}
                    onInput={debounce(handler, 500)}
                />
            </div>
        </div>);
});

CustomCaptcha.propTypes = {
    setCaptchaResult: PropTypes.func.isRequired,
}

CustomCaptcha.defaultProps = {
    setCaptchaResult: () => {},
}

export default CustomCaptcha;

